
<template>
<!-- vheight -->
  <div class="vheight propInformation">
    <div
      class="header-seacher"
      v-resize="redraw"
      :inline="true"
      style="border-bottom: 0px dotted #797979;"
    ></div>
    <div
      class="container-boot"
      :style="{height:'calc(100%)'}"
      style="padding-right: 10px;padding-left: 10px;"
    >
      <el-tabs
        style="margin-top: 10px;"
        type="border-card"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="基本信息" name="first"></el-tab-pane>
        <el-tab-pane label="良好信息" name="second"></el-tab-pane>
        <el-tab-pane label="不良信息" name="third"></el-tab-pane>
      </el-tabs>
      <!-- first show -->
      <div v-show="activeName === 'first'" class="grid">
        <ul class="menu-list">
          <li class="list-panel" >
            <div class="panel-title">企业名称：</div>
            <div class="panel-content">{{detail.orgName}}</div>
          </li>
          
          <li class="list-panel" >
            <div class="panel-title">业委会主任：</div>
            <div class="panel-content">{{detail.masterName}}</div>
          </li>
          <li class="list-panel" >
            <div class="panel-title">业主姓名：</div>
            <div class="panel-content">{{peopleName}}</div>
          </li>
          <li class="list-panel" >
            <div class="panel-title">物业项目：</div>
            <div class="panel-content">{{detail.eaAreaName}}</div>
          </li>
          <li class="list-panel" >
            <div class="panel-title">物业项目：</div>
            <div class="panel-content">{{eaAreaName}}</div>
          </li>
          <li class="list-panel" > 
            <div class="panel-title">业委会名称：</div>
            <div class="panel-content">{{detail.ownerTeamName  || '暂无'}}</div>
          </li>
          <li class="list-panel" >
            <div class="panel-title">表彰信息：</div>
            <div class="panel-content">{{detail.good}}次</div>
          </li>
          <li class="list-panel" >
            <div class="panel-title">绿色物业：</div>
            <div class="panel-content">{{detail.green}}次</div>
          </li>
          <li class="list-panel" >
            <div class="panel-title">幸福小区：</div>
            <div class="panel-content">{{detail.happy}}次</div>
          </li>
          <li class="list-panel" >
            <div class="panel-title">绿色物业星级评价：</div>
            <div class="panel-content">{{detail.star}}次</div>
          </li>
          <li class="list-panel" >
            <div class="panel-title">绿色物业示范项目：</div>
            <div class="panel-content">{{detail.model}}次</div>
          </li>
          <li class="list-panel"  >
            <div class="panel-title">连续六个月前十次数：</div>
            <div class="panel-content">{{detail.top10}}次</div>
          </li>
        </ul>
      </div>
      <!-- second show -->
      <div v-show="activeName === 'second'" class="grid">

      </div>
      <!--  -->
      <div v-show="activeName === 'third'" class="grid">

      </div>
    </div>
  </div>
</template>
<script>
import { CreditInformationController } from '@/service/PublicCreditInformation/CreditInformationController.js';
import { headerredraw } from '@/mixin/headerredraw';
import { mapState } from 'vuex';
import { Page } from '@/models/page';
export default {
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      activeName: 'first', 
      tableData:[],
      tableGoodData:[],
      tableBadData:[],
      realtyMgekeyWord:'',
      page: new Page(),
      orgCode: ''
    }
  },
  computed: { ...mapState(['token', 'userInfo']) },
  created() {
    this.CreditInformationController = new CreditInformationController();
  },
  mounted() {
    //this.orgCode = this.$route.query.orgCode;
     this.getDetailData('first');
  },
  filters: {
        getProbability(num1,num2){
            if(num1==0||num2==0){
                return 0;
            }else{
                return (parseFloat(num1)/parseFloat(num2)*100).toFixed(2);
            }
        },
    }, 
  methods: {
    search(){},
    handleClick(tab, event) {
      if (tab.name === 'first') this.getDetailData(tab.name);
      if (tab.name === 'second') this.getDetailData(tab.name);
      if (tab.name === 'third') this.getDetailData(tab.name);
    },

    showPara() {},
    indexMethod(index) {
      return index + 1 + (this.page.currentPage - 1) * this.page.currtNum;
    },
    getDetailData(activename) { 
      if (activename === 'first') {
        this.CreditInformationController.GetBasicInformationList( 
          this.realtyMgekeyWord,
         (this.page.currentPage - 1) * this.page.currtNum,
         this.page.currtNum
        )
          .then(res => { 
            if (res && res._Items) {
              this.tableData =res._Items; 
              this.page.getCurrtNum = res.TotalCount;
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error
            });
          });
      } else {
        //activename second 良好传值1，其他传0
        this.CreditInformationController.GetBehaviorList( 
          this.realtyMgekeyWord,
          activename=='second'?1:0,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum,
          true
        )
          .then(res => {
            if (res && res._item) {
              if(activename==='second'){
                 this.tableGoodData=res._item;
              }else{
                this.tableBadData=res._item;
              } 
            }
          })
          .catch(error => {
            this.loading = false;
            this.$message({
              type: 'error',
              message: error
            });
          });
      }
    }
  }
}
</script>
<style lang="scss">
.el-tabs--border-card > .el-tabs__content {
  padding: 0px;
}
.propInformation {
  .el-tabs__content {
    padding: 0px;
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.propInformation {
  // height: 100%;
  .search {
      width: 50%;
      display: flex;
      padding: 15px 0;
  }
  .basInfo-table {
    overflow: auto;
    .row {
      margin-right: 0;
      margin-left: 0;
      @media screen and (max-width: 992px) {
        flex-wrap: wrap !important;
      }
      .col-define {
        font-size: 14px;
        line-height: 42px;
        min-width: 150px;
        overflow: hidden;
        color: #666;
        border-bottom: 1px solid #e2e2e2;
        .col-chld {
          display: inline-block;
          width: 25%;
          & > div:nth-child(1) {
            display: inline-block;
            width: 30%;
            vertical-align: top;
          }
          & > div:nth-child(2) {
            display: inline-block;
            width: 70%;
          }
        }
      }
      .col-define:nth-child(2n) {
        flex: 1;
        border-right: 1px dotted #e2e2e2;
        padding-left: 24px;
      }

      .col-define:nth-child(2n-1) {
        text-align: right;
      }

      .col-tips {
        border-right: 1px dotted #e2e2e2;
      }
    }
  }
  .PublicInformationDetail-footer {
    text-align: right;
    margin: 20px;
  }
}
.propInformation {
  width: 100%;
  box-sizing: border-box;
  .header-seacher {
    @media screen and (max-width: 992px) {
      min-width: 0 !important;
      overflow-x: scroll;
    }
  }
  .function {
    min-width: 400px;
  }
  .container-boot {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
    transition: height 0.3s;
    .container-header {
      width: 100%;
      padding-top: 10px;
      box-sizing: border-box;
    }
    .grid {
      height: calc(100% - 30px);
    }
  }
  .footer {
    display: flex;
    flex-direction: row-reverse;
    margin-right: 10px;
    .fun {
      font-size: 14px;
      color: #409eff;
      cursor: pointer;
      .delete {
        margin-left: 20px;
      }
    }
  }
  .page{
     z-index: 100;
  }
}
</style>